var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apprentice-simple-card"},[_c('div',{staticClass:"row",staticStyle:{"display":"none"}},[_c('design-2021-digistudies-search')],1),_vm._v(" "),_c('design-2021-digitalstudies-subjects-grid',{attrs:{"digitalstudiesdisciplines":_vm.digitalstudiesdisciplines}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }